import { defineComponent as n, computed as t, openBlock as s, createElementBlock as i, normalizeStyle as d, normalizeClass as c, createElementVNode as m, renderSlot as p } from "vue";
const g = ["id"], u = { class: "mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" }, v = /* @__PURE__ */ n({
  __name: "LandingSectionWrapper",
  props: {
    bg: { default: "white" },
    size: { default: "md" },
    id: {},
    primary: { default: "var(--base-colors-primary-primary800)" }
  },
  setup(a) {
    const r = a, l = {
      sm: "py-12 md:py-16",
      md: "py-16 md:py-20 lg:py-24",
      lg: "py-20 md:py-24 lg:py-32"
    }, o = t(() => ({
      background: r.bg === "white" ? "var(--base-colors-neutral-neutral000)" : r.bg === "light" ? "var(--base-colors-common-light-gray-f5)" : "var(--base-colors-neutral-neutral750)",
      "--landing-primary": r.primary,
      "--landing-primary-400": "var(--base-colors-primary-primary400)",
      "--landing-dark": "var(--base-colors-neutral-neutral750)",
      "--landing-bg-light": "var(--base-colors-common-light-gray-f5)",
      "--landing-dark-900": "var(--base-colors-neutral-neutral800)",
      "--landing-dark-600": "var(--base-colors-neutral-neutral700)"
    }));
    return (e, y) => (s(), i("section", {
      id: a.id,
      class: c(l[a.size]),
      style: d(o.value)
    }, [
      m("div", u, [
        p(e.$slots, "default")
      ])
    ], 14, g));
  }
});
export {
  v as default
};
